import type { Flag, FlagSeverity } from "@shared/types";

const SEVERITY: Record<FlagSeverity, { dot: string; cls: string; label: string }> = {
  critical: { dot: "bg-critical", cls: "bg-critical-50 text-critical-700 border-critical/20", label: "Critical" },
  warning: { dot: "bg-warn", cls: "bg-warn-50 text-warn-700 border-warn/20", label: "Warning" },
  info: { dot: "bg-accent", cls: "bg-accent-50 text-accent-700 border-accent/20", label: "Info" },
};

export default function FlagChip({
  flag,
  onClose,
}: {
  flag: Flag;
  onClose?: (flag: Flag) => void;
}) {
  const s = SEVERITY[flag.severity];
  const closed = flag.status === "closed";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${
        closed ? "border-ink-200 bg-ink-100 text-ink-400 line-through" : s.cls
      }`}
      title={`${s.label}${flag.source === "auto" ? " · auto" : " · manual"}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${closed ? "bg-ink-300" : s.dot}`} />
      {flag.message}
      {onClose && !closed && (
        <button
          onClick={() => onClose(flag)}
          className="ml-0.5 rounded-full px-1 text-ink-400 hover:text-ink-700"
          aria-label="Close flag"
        >
          ✕
        </button>
      )}
    </span>
  );
}
